import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { ErrorCross } from "icons";

import { Modal, CardContent, Typography, WhiteSpace, MeButton, ModalProps } from ".";

export interface ErrorModalProps extends ModalProps {
  title?: string;
  subtitle?: React.ReactNode;
  failButton?: string;
}

export const ErrorModal = ({ title, subtitle, failButton, onClose, ...props }: ErrorModalProps) => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();

  const closeAndReload = () => {
    onClose?.();
    navigate(0);
  };

  return (
    <Modal size="sm" onClose={onClose} {...props}>
      <CardContent>
        <WhiteSpace v="2rem" />

        <Typography align="center">
          <ErrorCross size="100px" />
          <h2>{title || t("error_modal.title")}</h2>
          <p>{subtitle || t("error_modal.subtitle")}</p>
          <WhiteSpace v="1rem" />
          <MeButton onClick={closeAndReload}>{failButton || t("error_modal.fail_button")}</MeButton>
        </Typography>

        <WhiteSpace v="2rem" />
      </CardContent>
    </Modal>
  );
};
